<div>
  <ng-container *ngIf="loading">
    <div class="loading-spinner">
      <mat-spinner strokeWidth="3" diameter="50"></mat-spinner>
    </div>
  </ng-container>

  <ng-container *ngIf="!loading">
    <ng-container *ngIf="!applications || applications.length <= 0">
      <div class="noMenuMessage">No dashboards to display.</div>
    </ng-container>
    <ng-container *ngFor="let app of applications">
      <span class="app" *ngIf="app.dashboardId">
        <div class="icon" (click)="gotoDashboard(app.dashboardId)">
          <img class="icon" [src]="app.brandIconUrl" />
          {{ app.name }}
        </div></span
      ></ng-container
    ></ng-container
  >
</div>
